// -----------------------------------------------------------------
// List of collections in firestore
// -----------------------------------------------------------------

export const DB_COLLECTIONS = {
  CATEGORIES: "categories",
  USERS: "users",
  USERS_PRIVATE: "users_private",
  USERS_DETAILS: "users_details",
  CONTACTS: "contacts",
  SPONSORS: "sponsors",
  STANDS: "stands",
  VISITORS: "visitors", // stands sub
  MEMBERS: "members", // stands sub
  BUSY_SLOTS: "busy_slots", // stands sub
  BUSINESS_CARDS: "business_cards",
  TIMING: "timing",
  LIVE_VISITORS: "live_visitors",
  EVENTS: "events",
  EVENTS_PER_DAY: "events_per_day",
  EVENTS_PARTICIPANTS: "event_participants",
  APPOINTMENTS: "appointments",
  TOP_KEYWORDS: "top_keywords",
};

export const DB_DEFAULTS = {
  LIMIT: 30,
};
